import http from '@/communication/AuthConnection'

export default (pData) => {
  return http.post('/v1/permission', pData)
    .then(pData => pData.data)
}



// WEBPACK FOOTER //
// ./src/brain/record/permission/AddNewPermission.js